import React, { useEffect, useReducer, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Box, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import { useFormBaseStyles } from './styles';
import {
  formValidate,
  successesCounterInState,
  defineCommentHelper,
  selectStateContactForms,
} from '../../../helpers/FormHelper';
import { useDispatch, useSelector } from 'react-redux';
import { dispatchBodyGenerator } from '../../../helpers/FormHelper';
import AuthorizeCheckbox from '../AuthorizeCheckbox';
import LoadingButton from '../LoadingButton';
import Alerts from '../Alerts';
import Message from '../Message';
import { resetCreation } from '../../../redux/slices/TicketsSlice';
import { createTicket } from '../../../redux/actions/TicketsActions';
import {
  TICKET_SUCCESSFUL,
  TICKET_ERROR,
  TICKET_SUCCESSFUL_INNER_FORMS,
  RPHONE,
  PROVIDERS,
} from '../../../constants/routes';

const reducer = (state, { field, value }) => {
  return { ...state, [field]: value };
};

const FormBase = ({ ...props }) => {
  const {
    buttonTitle,
    issueForm,
    mobile,
    title,
    form,
    makeInitialState,
    fields,
    pre,
    formName,
    data,
    schema,
    onState,
    onValid,
    motiveId,
    typeId,
    validLength,
    info,
    messageInfo,
  } = props;
  const [valid, setValid] = useState(false);
  const [state, dispatch] = useReducer(reducer, makeInitialState(fields));
  const [checked, setChecked] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [alertMessages, setAlertMessages] = useState('');
  const classes = useFormBaseStyles({ mobile, issueForm });
  const reduxDispatch = useDispatch();
  const { creationStatus, ticketId, dataTicket } = useSelector(
    (state) => state.ticketsReducer,
  );
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    if (Object.entries(data).length > 0) {
      const { name, value: newValue } = data;
      const body = {
        newValue,
        helperText: defineCommentHelper(name, newValue),
      };
      const dispatchBody = dispatchBodyGenerator(state, name, body);
      dispatch(dispatchBody);
    }
    if (Object.entries(state).length > 0 && Object.entries(data).length > 0)
      formValidate(data, state, schema, dispatch);
  }, [data]);

  useEffect(() => {
    onState(state);
    setValid(successesCounterInState(state, validLength));
  }, [state, validLength]);

  useEffect(() => {
    onValid(valid);
  }, [valid]);

  useEffect(() => {
    if (creationStatus === 'succeded' && ticketId !== -1 && ticketId !== '') {
      if (location.pathname === RPHONE || location.pathname === PROVIDERS) {
        history.push(TICKET_SUCCESSFUL_INNER_FORMS, { mobile });
      } else {
        history.push(TICKET_SUCCESSFUL, { mobile });
      }
      reduxDispatch(resetCreation());
      setOpenAlert(false);
    }
    if (creationStatus === 'succeded') {
      history.push(TICKET_SUCCESSFUL_INNER_FORMS, { mobile });
      reduxDispatch(resetCreation());
      setOpenAlert(false);
      return; // Early return for the DEBIT path
    }

    if (creationStatus === 'error') {
      history.push(TICKET_ERROR, { mobile });
      reduxDispatch(resetCreation());
    }

    if (ticketId === -1) {
      setOpenAlert(true);
      let rutMessage = dataTicket?.rut ? dataTicket.rut : '';
      let emailMessage = dataTicket?.correo ? dataTicket.correo : '';
      setAlertMessages(`${rutMessage} ${emailMessage}`);
    } else {
      setOpenAlert(false);
    }
  }, [creationStatus, ticketId, location.pathname, mobile, reduxDispatch]);

  const handleClick = () => {
    const sendData = selectStateContactForms(
      state,
      location.pathname,
      motiveId,
      typeId,
    );
    reduxDispatch(createTicket(sendData));
  };

  return (
    <Box className={classes.container}>
      <div className={classes.message}>
        {info && <Message message={messageInfo} severity="info" fullRounded />}
      </div>
      <Typography className={classes.title}>{title} </Typography>
      {form}
      {!pre && (
        <React.Fragment>
          <AuthorizeCheckbox
            disabled={!valid}
            idComplement={formName}
            onCheck={(e) => setChecked(e)}
          />
          <LoadingButton
            name={formName}
            variant="contained"
            color="primary"
            text={buttonTitle || 'Enviar autorización'}
            disabled={!(valid && checked)}
            onClick={handleClick}
            loading={creationStatus === 'loading'}
          />
          <Alerts
            severity="error"
            openAlert={openAlert}
            messages={alertMessages}
            mobile={mobile}
          />
        </React.Fragment>
      )}
    </Box>
  );
};

FormBase.propTypes = {
  buttonTitle: PropTypes.string,
  issueForm: PropTypes.bool,
  mobile: PropTypes.bool,
  title: PropTypes.string,
  form: PropTypes.element,
  makeInitialState: PropTypes.func,
  fields: PropTypes.array,
  pre: PropTypes.bool,
  formName: PropTypes.string,
  data: PropTypes.object,
  schema: PropTypes.object,
  onState: PropTypes.func,
  onValid: PropTypes.func,
  motiveId: PropTypes.string,
  typeId: PropTypes.string,
  validLength: PropTypes.number,
  info: PropTypes.bool,
  messageInfo: PropTypes.string,
};

export default FormBase;
